/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'multiselect-selected': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><path pid="0" d="M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm5.2 9.87l-5.76 5.83c-.4.41-1.05.41-1.45 0L6.8 12.47c-.4-.41-.4-1.06 0-1.47l.09-.09c.4-.41 1.05-.41 1.45 0l2.37 2.4 4.93-4.99c.4-.42 1.06-.42 1.47-.02l.09.1c.4.4.4 1.06 0 1.47z" id="svgicon_multiselect-selected_a"/></defs><use _fill="#000" xlink:href="#svgicon_multiselect-selected_a" fill-rule="evenodd"/>'
  }
})
